import {
  Component,
  output,
  input,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { UserRole, UserStatus } from '#backend/common/user-types';
import { SelectOption } from '../../types/select-option';

export interface UserFilters {
  searchText: string;
  role: UserRole | '';
  status: UserStatus | '';
  organizationId: number | null;
}

@Component({
  selector: 'app-user-filters',
  standalone: true,
  imports: [
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
  ],
  templateUrl: './user-filters.component.html',
  styleUrls: ['./user-filters.component.scss'],
})
export class UserFiltersComponent implements OnInit, OnChanges {
  filters = input<UserFilters>({
    searchText: '',
    role: '',
    status: '',
    organizationId: null,
  });

  roles = input<SelectOption<UserRole>[]>([]);
  statuses = input<SelectOption<UserStatus>[]>([]);
  companies = input<SelectOption<number>[]>([]);
  showCompanyFilter = input(true);

  searchChange = output<string>();
  roleChange = output<UserRole | ''>();
  statusChange = output<UserStatus | ''>();
  companyChange = output<number | null>();
  clearFilters = output<void>();
  createUser = output<void>();

  searchText = '';
  selectedRole: UserRole | '' = '';
  selectedStatus: UserStatus | '' = '';
  selectedCompany: number | '' = '';

  ngOnInit() {
    const currentFilters = this.filters();
    this.searchText = currentFilters.searchText;
    this.selectedRole = currentFilters.role;
    this.selectedStatus = currentFilters.status;
    this.selectedCompany =
      currentFilters.organizationId !== null
        ? currentFilters.organizationId
        : '';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['filters'] && !changes['filters'].firstChange) {
      const currentFilters = this.filters();
      this.searchText = currentFilters.searchText;
      this.selectedRole = currentFilters.role;
      this.selectedStatus = currentFilters.status;
      this.selectedCompany =
        currentFilters.organizationId !== null
          ? currentFilters.organizationId
          : '';
    }
  }

  onSearchChange() {
    this.searchChange.emit(this.searchText);
  }

  clearSearch() {
    this.searchText = '';
    this.searchChange.emit('');
  }

  onRoleChange() {
    this.roleChange.emit(this.selectedRole);
  }

  onStatusChange() {
    this.statusChange.emit(this.selectedStatus);
  }

  onCompanyChange() {
    this.companyChange.emit(
      this.selectedCompany === '' ? null : Number(this.selectedCompany),
    );
  }

  onClearFilters() {
    this.searchText = '';
    this.selectedRole = '';
    this.selectedStatus = '';
    this.selectedCompany = '';
    this.clearFilters.emit();
  }

  onCreateUser() {
    this.createUser.emit();
  }
}
